<mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
  <mat-tab label="Basic Information">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="container">
        <div class="full-width-container">
          <section class="section-container nrg-border-radius">
            <div class="section-header">
              Basic Information
            </div>
            <div class="section-content">
              <div class="form-field-container-year-with-warning">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Year</mat-label>
                  <mat-select formControlName="year" required>
                    <mat-option *ngFor="let year of years" [value]="year">
                      {{ year }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="showYearWarning" class="warning-message">
                  <mat-icon>warning</mat-icon>
                  <span>There is no data for the selected year</span>
                </div>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Full Name</mat-label>
                  <input matInput formControlName="fullName" required appTextNormalize>
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Address</mat-label>
                  <input matInput formControlName="address">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Website</mat-label>
                  <input matInput formControlName="website">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email">
                </mat-form-field>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Country</mat-label>
                  <mat-select formControlName="country" [compareWith]="compareById">
                    <mat-option [value]="null">(None)</mat-option>
                    <mat-option *ngFor="let country of countries" [value]="country">
                      {{ country.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="form-field-container form-field-container-with-columns">
                <div class="form-field-container-half">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Category</mat-label>
                    <mat-select formControlName="category" [compareWith]="compareById">
                      <mat-option [value]="null">(None)</mat-option>
                      <mat-option *ngFor="let category of categories" [value]="category">
                        {{ category.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="form-field-container-half">
                  <mat-form-field appearance="fill" class="form-field">
                    <mat-label>Subcategory</mat-label>
                    <mat-select formControlName="subcategory" [disabled]="!form.get('category')?.value" [compareWith]="compareById">
                      <mat-option [value]="null">(None)</mat-option>
                      <mat-option *ngFor="let subcategory of subcategories" [value]="subcategory">
                        {{ subcategory.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-field-container">
                <mat-form-field appearance="fill" class="form-field">
                  <mat-label>Notes</mat-label>
                  <textarea matInput formControlName="notes" rows="4"></textarea>
                </mat-form-field>
              </div>
            </div>
          </section>
        </div>
      </div>

      @if (!hideActions) {
        <div class="form-actions">
          <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="!form.valid">
            <mat-icon>save</mat-icon>
            {{ submitButtonText }}
          </button>
          <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
            <mat-icon>clear</mat-icon>
            Cancel
          </button>
        </div>
      }
    </form>
  </mat-tab>
  <mat-tab label="Holdings" *ngIf="isEditMode">
    @if (!isLargeDataset) {
      <app-large-shareholder-holdings [holdings]="_holdings" />
    } @else {
      <app-large-shareholder-holdings-paginated [holdings]="_holdings" />
    }
  </mat-tab>
  <mat-tab label="Connections" *ngIf="isEditMode">
    <app-large-shareholder-connections
      [connections]="connections"
      (deleteConnection)="onDeleteConnection($event)">
    </app-large-shareholder-connections>
  </mat-tab>
  <mat-tab label="Pyramid" *ngIf="isEditMode">
    <app-large-shareholder-pyramid
      [pyramid]="pyramid"
      [pyramidEntitySummaries]="pyramidEntitySummaries"
      [selectedYear]="form.get('year')?.value ? parseInt(form.get('year')?.value) : undefined"
      [pyramidEntriesByYear]="pyramidEntriesByYear"
      (editPyramidItem)="onEditPyramidItem($event)"
      (deletePyramidItem)="onDeletePyramidItem($event)"
      (deleteEntityYear)="onDeleteEntityYear($event)"
      (deletePyramidYear)="onDeletePyramidYear($event)">
    </app-large-shareholder-pyramid>
  </mat-tab>
</mat-tab-group>

